import request from '@/utils/request'

// 广告列表
export const listAdvertisement = (pageData, formData) => {
    return request.post(`/advertisement/page/${pageData.page}/${pageData.pageSize}`, formData);
};

// 广告待上架列表
export const listAdvertisementOfPendingOnline = (pageData, formData) => {
    return request.post(`/advertisement/pendingOnline/page/${pageData.page}/${pageData.pageSize}`, formData);
};

// 广告待审批列表
export const listAdvertisementOfPendingReview = (pageData, formData) => {
    return request.post(`/advertisement/pendingReview/page/${pageData.page}/${pageData.pageSize}`, formData);
};

// 新增广告
export const addAdvertisement = (formData) => {
    return request.post(`/advertisement`, formData);
};

// 广告详情
export const detailAdvertisement = (id) => {
    return request.get(`/advertisement/${id}`);
};

// 修改广告
export const editAdvertisement = (updateData) => {
    return request.put(`/advertisement`, updateData)
}

// 审核广告
export const editAdvertisementReviewState = (updateData) => {
    return request.put(`/advertisement/reviewState`, updateData)
}

// 广告下架
export const changeAdvertisementToOffline = (advertisementId) => {
    return request.put(`/advertisement/offline/${advertisementId}`)
}

// 设置默认广告
export const setAdvertisementDefault = (advertisementId, isDefault) => {
    return request.put(`/advertisement/default/${advertisementId}/${isDefault}`)
}
